import React, {useEffect, useState} from 'react';
import {PremiumInfo, usePulsoidClient} from '../../../../PulsoidClient';
import {ButtonV2} from '../../../../system/ButtonV2/ButtonV2';
import css from './BroPlanSideBarButton.module.css';
import {
  PaddleEventType,
  PaddleProviderInstance,
} from '../../../../system/paddle/PaddleProvider';

let PaddleCallerId = 'bro-plan-update-payment-method-side-bar';

let ForceShowUpdatePaymentMethod = false;

export const BroPlanSideBarButton = (props) => {
  const client = usePulsoidClient();
  const [premiumInfo, setPremiumInfo] = useState<PremiumInfo | null>(null);
  const [checkoutCompleted, setCheckoutCompleted] = useState(false);
  const [checkoutClosed, setCheckoutClosed] = useState(false);

  useEffect(() => {
    client.getPremiumInfo().then((info) => {
      setPremiumInfo(info);
    });
    return () => {
      PaddleProviderInstance.unsubscribe(PaddleCallerId);
    };
  }, []);

  useEffect(() => {
    // if checkout is completed and closed then reset the state in 5 seconds
    let timeoutId: any = null;
    if (checkoutCompleted && checkoutClosed) {
      timeoutId = setTimeout(() => {
        setPremiumInfo(null);
        setCheckoutCompleted(false);
        setCheckoutClosed(false);
        client.getPremiumInfo().then((info) => {
          setPremiumInfo(info);
        });
      }, 5000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [checkoutCompleted, checkoutClosed]);

  let component = <></>;
  if (
    (premiumInfo?.isPastDue && premiumInfo?.updateUrl) ||
    ForceShowUpdatePaymentMethod
  ) {
    component = (
      <div className={css.container}>
        <div>BRO plan payment failed</div>
        <ButtonV2
          type="warning"
          onClick={() => {
            client.reportUPMSideBarOpened();
            PaddleProviderInstance.checkoutOpen(
              {
                override: premiumInfo?.updateUrl,
              },
              {
                subscriberId: 'bro-plan-update-payment-method-side-bar',
                onEvent: (event: PaddleEventType) => {
                  if (event.event === 'Checkout.Complete') {
                    setCheckoutCompleted(true);
                    client.reportUPMSideBarCompleted();
                    return 'keep';
                  }
                  if (event.event === 'Checkout.Close') {
                    setCheckoutClosed(true);
                    client.reportUPMSideBarClosed();
                    return 'remove';
                  }
                  return 'keep';
                },
              }
            );
            setCheckoutCompleted(false);
            setCheckoutClosed(false);
          }}
        >
          Update Payment Method
        </ButtonV2>
      </div>
    );
  }

  if (checkoutCompleted && checkoutClosed) {
    component = (
      <div className={css.container}>
        BRO plan payment method has been updated successfully
      </div>
    );
  }

  return component;
};
